<script lang="ts" setup>
  import { useElementSize, watchDebounced } from '@vueuse/core';
  import { computed, nextTick, onMounted, ref, watchEffect } from 'vue';
  import { ImageVerificationProps } from './image-verification';

  defineOptions({
    name: 'IImageVerification',
  });

  defineProps(ImageVerificationProps);
  const emits = defineEmits({
    'update:modelValue': (value: string) => value,
    refresh: () => true,
  });

  const CODE_STRING = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']; // 验证码字符串
  const CODE_LENGTH = 4; // 验证码长度

  const imgVerifyRef = ref();
  // @ts-ignore
  const { width, height } = useElementSize(imgVerifyRef);
  const imgVerify = computed(() => {
    return { width: width.value, height: height.value };
  });
  const canvasRef = ref<HTMLCanvasElement>();
  const imgCodeText = ref('');
  onMounted(() => handleRefresh());
  watchEffect(() => {
    if (imgCodeText.value) {
      emits('update:modelValue', imgCodeText.value);
    }
  });
  watchDebounced(
    () => imgVerify.value,
    () => handleRefresh(),
  );
  defineExpose({
    refresh: handleRefresh,
  });

  /**
   * 刷新验证码
   */
  async function handleRefresh() {
    if (canvasRef.value) {
      await sleep(100);
      await nextTick();
      imgCodeText.value = drawCode(canvasRef.value, width.value, height.value);
    } else {
      console.error('canvas获取上下文失败');
    }
  }

  /**
   * 绘制验证码
   * @param canvas
   * @param w
   * @param h
   */
  function drawCode(canvas: HTMLCanvasElement, w: number, h: number): string {
    const ctx = canvas.getContext('2d');
    let codeText = '';
    if (!ctx) return '';
    ctx.fillStyle = randomColor(180, 230); // 背景色
    ctx.fillRect(0, 0, w, h); // 矩形填充区域
    for (let i = 0; i < CODE_LENGTH; i++) {
      // 字符
      const text = CODE_STRING[randomNum(0, CODE_STRING.length)];
      codeText += text;
      // 字体大小
      const fontSize = randomNum(h - 6, h);
      // 字体样式
      ctx.font = `550 ${fontSize}px Simhei`;
      // 基线对齐
      ctx.textBaseline = 'top';
      // 文本对齐
      ctx.textAlign = 'left';
      ctx.fillStyle = randomColor(50, 160);
      ctx.save();
      ctx.translate((w / (CODE_LENGTH + 1)) * i, 0);
      ctx.rotate((randomNum(-10, 10) * Math.PI) / 180);
      ctx.fillText(text, 5, 0);
      ctx.restore();
    }
    return codeText;
  }

  function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  /**
   * 根据min和max随机返回一个随机数
   * @param min
   * @param max
   */
  function randomNum(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min) + min);
  }
  /**
   * 返回一个随机颜色(rgb格式)
   * @param min 色值最小值
   * @param max 色值最大值
   */
  function randomColor(min: number, max: number): string {
    const r = randomNum(min, max);
    const g = randomNum(min, max);
    const b = randomNum(min, max);
    return `rgb(${r},${g},${b})`;
  }
</script>

<template>
  <div ref="imgVerifyRef" class="t-img-verify">
    <canvas ref="canvasRef" :width="imgVerify.width" :height="imgVerify.height" @click="handleRefresh" />
  </div>
</template>
